// src/index.ts
var PHASE_CONFIG = {
  QUALIFIER: {
    startRadius: 200,
    endRadius: 32,
    startSpeed: 20,
    endSpeed: 160,
    jitterAmplitudeStart: 2,
    jitterAmplitudeEnd: 10,
    noiseMaxPercent: 0.35,
    description: "Open qualifiers - standard difficulty"
  },
  SHORTLIST: {
    startRadius: 180,
    endRadius: 28,
    startSpeed: 80,
    endSpeed: 190,
    jitterAmplitudeStart: 3,
    jitterAmplitudeEnd: 12,
    noiseMaxPercent: 0.3,
    description: "Shortlist phase - increased difficulty"
  },
  SEMIFINAL: {
    startRadius: 160,
    endRadius: 22,
    startSpeed: 120,
    endSpeed: 260,
    jitterAmplitudeStart: 5,
    jitterAmplitudeEnd: 16,
    noiseMaxPercent: 0.4,
    description: "Semifinal phase - high difficulty"
  },
  FINAL: {
    startRadius: 140,
    endRadius: 26,
    startSpeed: 120,
    endSpeed: 230,
    jitterAmplitudeStart: 4,
    jitterAmplitudeEnd: 12,
    noiseMaxPercent: 0.3,
    description: "Finals - maximum difficulty"
  },
  CLOSED: {
    startRadius: 200,
    endRadius: 32,
    startSpeed: 20,
    endSpeed: 160,
    jitterAmplitudeStart: 2,
    jitterAmplitudeEnd: 10,
    noiseMaxPercent: 0.35,
    description: "Season closed - no games allowed"
  }
};
var CURVE_EXPONENTS = {
  radius: 2.4,
  // Exponential ease-in: shrinks slowly early, fast late
  speed: 1.6,
  // Power ramp: accelerates over time
  jitter: 2,
  // Quadratic: smooth increase
  noise: 1.5
  // Sub-quadratic: gradual unpredictability
};
var SCORING_CONFIG = {
  precisionErrorMultiplier: 0.8
  // Score = survival_time_ms - (precision_error * this)
};
var PHASE_DURATIONS = {
  production: {
    QUALIFIER: 3 * 24 * 60,
    // 3 days in minutes
    SHORTLIST: 2 * 24 * 60,
    // 2 days
    SEMIFINAL: 1 * 24 * 60,
    // 1 day
    FINAL: 1 * 24 * 60,
    // 1 day
    CLOSED: 0
  },
  testing: {
    QUALIFIER: 10,
    // 10 minutes
    SHORTLIST: 10,
    SEMIFINAL: 10,
    FINAL: 10,
    CLOSED: 0
  }
};
var CREDITS_CONFIG = {
  creditsPerPack: 5,
  solPerPack: 0.1,
  maxPacksPerPurchase: 2,
  freeCreditsPerPhase: 3,
  // Free credits given at start of each phase
  revenueSplit: {
    prizePool: 50,
    // 50% to prize pool
    operations: 30,
    // 30% to operations
    buyBurn: 20
    // 20% to buy & burn
  }
};
var TOKEN_CONFIG = {
  symbol: "BG",
  minBalance: 25e3
  // Minimum BG tokens required to play
};
var GAME_PARAMS = {
  // Duration
  maxDuration: 45e3,
  // 45 seconds total game time
  // Circle sizing (defaults - overridden by phase config)
  startRadius: 200,
  // Starting circle radius in pixels
  endRadius: 32,
  // Minimum circle radius at end
  // Speed (defaults - overridden by phase config)
  startSpeed: 20,
  // Starting movement speed in px/s
  endSpeed: 160,
  // Max movement speed in px/s at end
  // Jitter/movement (defaults - overridden by phase config)
  jitterAmplitudeStart: 2,
  // Starting jitter amplitude in pixels
  jitterAmplitudeEnd: 10,
  // End jitter amplitude in pixels
  jitterFrequency: 100,
  // Milliseconds between jitter updates
  noiseMaxPercent: 0.35,
  // Max direction noise as percentage of speed
  // Failure conditions
  failThreshold: 150,
  // Milliseconds outside circle before fail (~5 ticks at 30Hz)
  positionTimeoutMs: 300,
  // Position considered stale if no data within this time (6 missed packets)
  graceperiodMs: 500,
  // Grace period at game start before enforcing position timeout
  // Network timing
  positionSendRate: 33,
  // Client sends position every 33ms (30/sec)
  serverTickRate: 33,
  // Server checks/broadcasts every 33ms (30/sec)
  // Countdown
  countdownSeconds: 3,
  // Anti-cheat thresholds
  antiCheat: {
    teleportThreshold: 150,
    // Max pixels between positions (reduced from 500)
    precisionThreshold: 0.05,
    // Min standard deviation (inhuman if below) - very low to avoid false positives
    packetGapThreshold: 500,
    // Max ms between packets before flagging
    maxDailyRuns: 100,
    // Max runs per wallet per day
    cooldownMs: 3e4
    // 30 second cooldown between runs
  }
};
var CANVAS_CONFIG = {
  width: 800,
  height: 600,
  backgroundColor: "#0a0a0a",
  circleColor: "#ffffff",
  circleGlowColor: "rgba(255, 255, 255, 0.3)",
  failureColor: "#ef4444",
  successColor: "#22c55e"
};
var ANIMATION_CONFIG = {
  breathingAmplitude: 3,
  // Pixels of idle breathing animation
  breathingSpeed: 2e3,
  // Full breath cycle in ms
  failureShakeDuration: 500,
  failureShakeIntensity: 10,
  fadeTransitionDuration: 300
};
var COLORS = {
  background: {
    primary: "#0a0a0a",
    secondary: "#141414",
    tertiary: "#1f1f1f"
  },
  text: {
    primary: "#fafafa",
    secondary: "#a1a1a1",
    muted: "#525252"
  },
  accent: {
    white: "#ffffff",
    success: "#22c55e",
    error: "#ef4444",
    warning: "#f59e0b"
  },
  game: {
    circle: "#ffffff",
    glow: "rgba(255, 255, 255, 0.3)",
    danger: "#ef4444"
  }
};
var TYPOGRAPHY = {
  fontFamilies: {
    sans: "Inter, system-ui, sans-serif",
    mono: "JetBrains Mono, monospace",
    display: "Space Grotesk, sans-serif"
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem"
  }
};
var SEASON_CONFIG = {
  minTokenBalance: TOKEN_CONFIG.minBalance,
  // Minimum BG tokens required
  tokenMint: "BG_TOKEN_MINT_ADDRESS",
  // Replace with actual mint address
  qualificationPhases: 4,
  qualificationSpotsPerPhase: [256, 64, 16, 4],
  phaseOrder: ["QUALIFIER", "SHORTLIST", "SEMIFINAL", "FINAL", "CLOSED"]
};
function calculateRadius(elapsedMs) {
  const t = Math.min(elapsedMs / GAME_PARAMS.maxDuration, 1);
  return GAME_PARAMS.endRadius + (GAME_PARAMS.startRadius - GAME_PARAMS.endRadius) * Math.pow(1 - t, CURVE_EXPONENTS.radius);
}
function calculateJitterAmplitude(elapsedMs) {
  const t = Math.min(elapsedMs / GAME_PARAMS.maxDuration, 1);
  return GAME_PARAMS.jitterAmplitudeStart + (GAME_PARAMS.jitterAmplitudeEnd - GAME_PARAMS.jitterAmplitudeStart) * Math.pow(t, CURVE_EXPONENTS.jitter);
}
function calculateMovementSpeed(elapsedMs) {
  const t = Math.min(elapsedMs / GAME_PARAMS.maxDuration, 1);
  return GAME_PARAMS.startSpeed + (GAME_PARAMS.endSpeed - GAME_PARAMS.startSpeed) * Math.pow(t, CURVE_EXPONENTS.speed);
}
function calculateNoiseMagnitude(elapsedMs, currentSpeed) {
  const t = Math.min(elapsedMs / GAME_PARAMS.maxDuration, 1);
  return GAME_PARAMS.noiseMaxPercent * currentSpeed * Math.pow(t, CURVE_EXPONENTS.noise);
}
function seededRandom(seed) {
  let state = seed || 1;
  return () => {
    state ^= state << 13;
    state ^= state >>> 17;
    state ^= state << 5;
    return (state >>> 0) / 4294967295;
  };
}
function createRng(seed) {
  let state = seed || 1;
  return {
    next() {
      state ^= state << 13;
      state ^= state >>> 17;
      state ^= state << 5;
      return (state >>> 0) / 4294967295;
    },
    // Generate noise vector for direction perturbation
    getNoiseVector() {
      const angle = this.next() * Math.PI * 2;
      return { x: Math.cos(angle), y: Math.sin(angle) };
    }
  };
}
function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash >>> 0;
}
function isInsideCircle(px, py, cx, cy, radius) {
  const dx = px - cx;
  const dy = py - cy;
  return dx * dx + dy * dy <= radius * radius;
}
function getGameParamsForPhase(phase) {
  const phaseConfig = PHASE_CONFIG[phase];
  return {
    ...GAME_PARAMS,
    startRadius: phaseConfig.startRadius,
    endRadius: phaseConfig.endRadius,
    startSpeed: phaseConfig.startSpeed,
    endSpeed: phaseConfig.endSpeed,
    jitterAmplitudeStart: phaseConfig.jitterAmplitudeStart,
    jitterAmplitudeEnd: phaseConfig.jitterAmplitudeEnd,
    noiseMaxPercent: phaseConfig.noiseMaxPercent
  };
}
function calculateRadiusForPhase(elapsedMs, phase) {
  const params = getGameParamsForPhase(phase);
  const t = Math.min(elapsedMs / params.maxDuration, 1);
  return params.endRadius + (params.startRadius - params.endRadius) * Math.pow(1 - t, CURVE_EXPONENTS.radius);
}
function calculateJitterAmplitudeForPhase(elapsedMs, phase) {
  const params = getGameParamsForPhase(phase);
  const t = Math.min(elapsedMs / params.maxDuration, 1);
  return params.jitterAmplitudeStart + (params.jitterAmplitudeEnd - params.jitterAmplitudeStart) * Math.pow(t, CURVE_EXPONENTS.jitter);
}
function calculateMovementSpeedForPhase(elapsedMs, phase) {
  const params = getGameParamsForPhase(phase);
  const t = Math.min(elapsedMs / params.maxDuration, 1);
  return params.startSpeed + (params.endSpeed - params.startSpeed) * Math.pow(t, CURVE_EXPONENTS.speed);
}
function calculateNoiseMagnitudeForPhase(elapsedMs, currentSpeed, phase) {
  const params = getGameParamsForPhase(phase);
  const t = Math.min(elapsedMs / params.maxDuration, 1);
  return params.noiseMaxPercent * currentSpeed * Math.pow(t, CURVE_EXPONENTS.noise);
}
function getPhaseNumber(phase) {
  const index = SEASON_CONFIG.phaseOrder.indexOf(phase);
  return index === -1 ? 1 : index + 1;
}
function getNextUtcMidnight() {
  const now = /* @__PURE__ */ new Date();
  const tomorrow = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() + 1,
    0,
    0,
    0,
    0
  ));
  return tomorrow;
}
export {
  ANIMATION_CONFIG,
  CANVAS_CONFIG,
  COLORS,
  CREDITS_CONFIG,
  CURVE_EXPONENTS,
  GAME_PARAMS,
  PHASE_CONFIG,
  PHASE_DURATIONS,
  SCORING_CONFIG,
  SEASON_CONFIG,
  TOKEN_CONFIG,
  TYPOGRAPHY,
  calculateJitterAmplitude,
  calculateJitterAmplitudeForPhase,
  calculateMovementSpeed,
  calculateMovementSpeedForPhase,
  calculateNoiseMagnitude,
  calculateNoiseMagnitudeForPhase,
  calculateRadius,
  calculateRadiusForPhase,
  createRng,
  getGameParamsForPhase,
  getNextUtcMidnight,
  getPhaseNumber,
  hashCode,
  isInsideCircle,
  seededRandom
};
